import store from '../init/store.js'

export function getBattleType() {
  //Quick utility for providing the right data to update the battle record.

  if (store.getState().battle.isMultiplayerMode) {
    return store.getState().matchmaking.currentRoomType || "unknownRoomType";
  } else {
    return "quick"; //Assume offline quick play.
  }

}


// WEBPACK FOOTER //
// ./src/battle/get-battle-type.js